import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34aa3751"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table")!
  const _component_dataLoad = _resolveComponent("dataLoad")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_dataLoad, { spinning: _ctx.spinning }, {
      default: _withCtx(() => [
        (!_ctx.spinning)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_Table, {
                data: _ctx.data,
                columns: _ctx.columns,
                bordered: true,
                pagination: false
              }, null, 8, ["data", "columns"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}